module.exports = __webpack_public_path__ + "img/yan_1.8dc5de9c.png";